<template lang="html">
  <section
    v-if="visible"
    v-on:click="onSelected"
    @keydown.enter.stop="onSelected"
  >
    <div class="m-list-option" :id="itemId">
      <div class="m-utility-icon slds-icon_container" v-if="hasIcon">
        <svg class=" slds-icon--small slds-icon-text-default">
          <use :xlink:href="getUtilityIcon(listItem)"></use>
        </svg>
      </div>
      <div class="m-text-items" v-if="boxType === 'createApp'">
        <div class="m-ellipsis" v-if="Name && !labelOnly" v-html="Name"></div>
        <div class="m-ellipsis" v-html="formattedName"></div>
      </div>
      <div
        v-if="boxType === 'deEditModal'"
        class="m-text-items"
        :class="{ 'item-selected': isMultiSelect && isSelected }"
      >
        <div class="m-ellipsis" v-html="label"></div>
        <div class="m-ellipsis" v-if="!labelOnly" v-html="name"></div>
        <div class="m-ellipsis" v-if="!labelOnly" v-html="dataType"></div>
      </div>
    </div>
    <b-tooltip
      v-if="hasDes && description"
      class="item-description"
      :target="itemId"
      triggers="hover"
      placement="left"
      delay="500"
    >
      {{ description }}
    </b-tooltip>
  </section>
</template>

<script lang="js">
  import { highlight } from "@/components/utils/highlight";
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
  export default  {
    name: "search-box-list-item",
    props: {
      listItem: {
        type: Object
      },
      exp: {
        type: String
      },
      boxType: {
        type: String
      },
      hasIcon: {
        type: Boolean
      },
      labelOnly: {
        type: Boolean
      },
      hasDes: {
        type: Boolean
      },
      itemId: {
        type: String
      },
      isMultiSelect: {
        type: Boolean,
        default: false
      },
      isSelected: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      if (this.boxType === 'createApp') {
        this.Name = this.listItem.Name;
        let accountFormattedName = this.listItem.Account_vod__r && this.listItem.Account_vod__r.Formatted_Name_vod__c ? this.listItem.Account_vod__r.Formatted_Name_vod__c : "";
        this.formattedName = this.listItem.Formatted_Name_vod__c || accountFormattedName;
      } else if (this.boxType === 'deEditModal') {
        this.name = this.listItem.name;
        this.label = this.listItem.value || this.listItem.label;
        this.dataType = this.listItem.dataType || "";
        this.description = this.listItem.description || "";
      }
      this.updateDisplay();
    },
    watch: {
      exp: function() {
        this.updateDisplay();
      }
    },
    data () {
      return {
        formattedName: "",
        Name: "",
        name: "",
        label: "",
        dataType: "",
        showDescription: false,
        description: "",
        visible: true
      }
    },
    methods: {
      onSelected() {
        if(this.isMultiSelect && this.isSelected) {
          this.$emit("on-search-box-item-deselected", this.listItem);
        } else {
          this.$emit("on-search-box-item-selected", this.listItem);
        }
      },
      updateDisplay() {
        this.visible = true;
        let formattedName = "";

        if (this.boxType === 'createApp') {
          let accountFormattedName = this.listItem.Account_vod__r && this.listItem.Account_vod__r.Formatted_Name_vod__c ? this.listItem.Account_vod__r.Formatted_Name_vod__c : "";
          formattedName = this.listItem.Formatted_Name_vod__c || accountFormattedName;
        } else if (this.boxType === 'deEditModal') {
          formattedName = this.listItem.label || this.listItem.value;
        }

        if(!this.exp) {
          if (this.boxType === 'createApp') {
            this.Name = this.listItem.Name;
            this.formattedName = formattedName;
          } else if (this.boxType === 'deEditModal') {
            this.name = this.listItem.name;
            this.label = formattedName;
            this.dataType = this.listItem.dataType;
            this.description = this.listItem.description;
          }
        } else {
          if (this.boxType === 'createApp') {
            this.formattedName = highlight.find(formattedName, this.exp);
            this.Name = highlight.find(this.listItem.Name, this.exp);
            if(this.formattedName === formattedName && this.Name === this.listItem.Name) {
              this.visible = false;
            }
          } else if (this.boxType === 'deEditModal') {
            this.label = highlight.find(formattedName, this.exp);
            this.name = highlight.find(this.listItem.name, this.exp);
            if (this.listItem.dataType) {
              this.dataType = highlight.find(this.listItem.dataType, this.exp);
            }

            if(this.label === formattedName && this.name === this.listItem.name) {
              this.visible = false;
            }
          }
        }
        this.listItem.visible = this.visible;
      },
        getUtilityIcon(listItem) {
          return iconsUri.getUtilityIconByType(listItem.type);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../styles/components/elements";
  .m-list-option-icon {
    svg {
      @include mixin-list-item-svg-icon;
    }
    padding: 0.188rem 0.75rem;
    margin-right: -0.75rem;
  }

  .m-utility-icon {
    padding-left: 8px;
  }

  .m-list-option {
    display: flex;
    align-items: center;
  }
  .m-text-items {
    overflow: hidden;
    padding: 0.75rem;
    width: 100%;
  }
  .selected-item-on-hover {
    .item-selected {
      color: #ffffff;
    }
  }
  .item-selected {
    color: #b0b0b0;
  }
  .item-selected:hover {
    background-color: #ff6a6a;
    color: #ffffff;
  }
  .b-tooltip {
    z-index: 10000;
    left: 200px !important;
  }
</style>
